// extracted by mini-css-extract-plugin
export default {"check":"VBRadioButton_check__nJRjB","active":"VBRadioButton_active__o4eNu"};